import qs from 'qs';

export default async ({
    enquiryType,
    savings,
    age,
    applicantFirstName,
    applicantLastName,
    applicantPhone = '',
    applicantEmail,
    createUserUrl,
    redirectUrl,
    showErrorMessage,
    disableSubmit,
    enableSubmit,
    triggerTracking,
}) => {
    try {
        disableSubmit();

        const formData = qs.stringify({
            [window.csrfTokenName]: window.csrfTokenValue,
            enquiry_type: enquiryType,
            savings: parseInt(savings, 10),
            age: parseInt(age, 10),
            first_name: applicantFirstName,
            last_name: applicantLastName,
            phone: applicantPhone,
            email: applicantEmail,
        });

        const response = await fetch(createUserUrl, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            credentials: 'same-origin',
            body: formData,
        });

        if (response.ok) {
            triggerTracking();
            const data = await response.json();

            if ('user_id' in data) {
                window.localStorage.setItem('userId', data.user_id);
            }

            window.location.href = redirectUrl;
        } else {
            const data = await response.json();
            if (data.message.indexOf('409') > -1) {
                showErrorMessage('You\'ve already enquired! Our team will be in touch soon, but feel free to <a class="text--blue-light" href="/contact">contact us</a>');
            } else {
                showErrorMessage();
            }
            enableSubmit();
        }

    } catch (error) {
        window.bugsnagClient.notify(error);
        showErrorMessage();
        enableSubmit();
    }
};



// WEBPACK FOOTER //
// ./app/scripts/components/crm.js